import { useState, useEffect } from "react";
import backarrow from "../../assets/svg/backarrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import "./device-group-create.css";
import { Row, Col } from "react-bootstrap";
import WidgetCreateModal from "./widget-setup-modal";
import { createGroupApi, getApplicationListApi, getGroupApi, updateGroupApi, getWidgetListApi, getInternalWidgetsApi } from "./device-group-api";
import AddApplicationModal from "./add-application-modal";
import DOMPurify from "dompurify";
import edit from "../../assets/svg/edit.svg";
import del from "../../assets/svg/delete.svg";

export default function DeviceGroupCreate() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");
  const [status, setStatus] = useState("Active");
  const [duration, setDuration] = useState("");
  const [interval, setInterval] = useState("");
  const [durationType, setDurationType] = useState("Sec");
  const [sequenceOrder, setSequenceOrder] = useState("");
  const [widgets, setWidgets] = useState([{ widget_type: "", chart: "", config: {} }]);
  const [errorMsg, setErrorMsg] = useState("");
  const [validations, setValidations] = useState({
    group_id: "",
    group_name: "",
    applications: "",
  });
  const [applicationType, setApplicationType] = useState("Internal");

  const [selectedApplicationName, setSelectedApplicationName] = useState("");
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [editApplication, setEditApplication] = useState(null);
  const [editApplicationIndex, setEditApplicationIndex] = useState(null);
  const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
  const [isAddApplicationModal, setIsAddApplicationModal] = useState(false);

  const [applicationList, setApplicationList] = useState([]);

  const [removedInternalList, setRemovedInternalList] = useState([]);
  const [removedExternalList, setRemovedExternalList] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {
    if (id != null) {
      getGroupDetails();
    }
    getApplicationList();
  }, []);
  useEffect(() => {
    if (editApplication != null) {
      setIsAddApplicationModal(true);
    } else {
      setEditApplicationIndex(null);
    }
  }, [editApplication]);
  const getApplicationList = async () => {
    try {
      const response = await getApplicationListApi(id);
      if (response.data.success === true) {
        setApplicationList(response.data.applications);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  /*   useEffect(() => {
    if (
      id != null &&
      selectedApplication != null &&
      applicationType === "Internal"
    ) {
      console.log("selectedApplication called");
      getApplicationWidgetList(selectedApplication.application_id);
    }
  }, [selectedApplication]);

  const getApplicationWidgetList = async (applicationId) => {
    try {
      const response = await getInternalWidgetsApi(applicationId, id);
      if (response.data.success === true) {
        const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
        if (index > -1) {
          const tempApp = [...applicationList];
          const updatedArr = response.data.suggestionlist.map((item) => {
            const match = selectedApplication.internal_widgets.find((obj) => obj.widget_id === item.value && obj.id != null && obj.id !== "");
            console.log(match);
            return match
              ? {
                  id: match.id,
                  name: item.label,
                  widget_id: match.widget_id,
                  seq_no: match.seq_no,
                  status: true,
                  width: match.width || "",
                  custom_width: match.custom_width || 0,
                }
              : {
                  id: 0,
                  widget_id: item.value,
                  name: item.label,
                  seq_no: "",
                  status: false,
                  width: "",
                  custom_width: 0,
                };
          });
          tempApp[index].internal_widgets = updatedArr;
          setSelectedApplication(tempApp[index]);
          setApplicationList(tempApp);
        }

        // setApplicationList(response.data.applications);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  }; */

  const getGroupDetails = async () => {
    const response = await getGroupApi(id);
    if (response.status === 200) {
      if (response.data.success === true) {
        const groupObj = response.data.group;
        setGroupId(groupObj.group_id);
        setGroupName(groupObj.group_name);
        setStatus(groupObj.status === true ? "Active" : "In-Active");
      }
    }
  };
  const onSuccessApplicationAdd = async (response) => {
    if (editApplicationIndex != null && editApplicationIndex > -1) {
      console.log("edited application");
      const index = applicationList.findIndex((app) => app === editApplication);
      const index2 = applicationList.findIndex((app) => (applicationType === "External" && app.name.toLowerCase() === response.name.toLowerCase()) || (applicationType === "Internal" && app.name.toLowerCase() === response.name.toLowerCase()));
      if (index === index2 || index2 === -1) {
        const tempApp = [...applicationList];
        tempApp[index] = response;
        setApplicationList(tempApp);
        setSelectedApplicationName(response.name);
        setSelectedApplication(response);
        setIsAddApplicationModal(false);
        setErrorMsg("");
        setEditApplication(null);
      } else {
        setErrorMsg("Application name already exist!");
      }
    } else {
      const index = applicationList.findIndex((app) => (applicationType === "External" && app.name.toLowerCase() === response.name.toLowerCase()) || (applicationType === "Internal" && app.name.toLowerCase() === response.name.toLowerCase()));

      if (index > -1) {
        setErrorMsg("Application name already exist!");
      } else {
        console.log("new application");
        const tempApp = [...applicationList];
        tempApp.push(response);
        setApplicationList(tempApp);
        setSelectedApplicationName(response.name);
        setSelectedApplication(response);
        setIsAddApplicationModal(false);
        setErrorMsg("");
        setEditApplication(null);
      }
    }
  };

  const submitGroup = async () => {
    const groupedTrueWidgets = applicationList.map((item) => ({
      ...item,
      removed_widgets: (Array.isArray(item.internal_widgets)
        ? item.internal_widgets
        : []
      )
        .filter(
          (obj) => obj.id != null && obj.id !== "" && obj.status === false
        )
        .map((item) => item.id),
      internal_widgets: (Array.isArray(item.internal_widgets)
        ? item.internal_widgets
        : []
      ).filter((obj) => obj.status === true).map((widget) => ({
          ...widget,
          width: widget.width ? widget.width : null,
          custom_width: widget.width === "custom" && widget.custom_width ? widget.custom_width : null,
        })),
    }));
    const dataBeforeSanitize = {
      id: id,
      group_id: groupId,
      group_name: groupName,
      status: status === "Active" ? true : false,
      applications: groupedTrueWidgets.filter((item) => item.selected_status === true),
      removed_internal_applications: removedInternalList,
      removed_external_applications: removedExternalList,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (id == null || id === "") {
      const response = await createGroupApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          navigate(-1);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            group_id: "",
            group_name: "",
            applications: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateGroupApi(id, dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          navigate(-1);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            group_id: "",
            group_name: "",
            applications: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  return (
    <div className="container-fluid px-0" style={{ overflowY: "auto", background: "#F5F7F9", width: "100wv" }}>
      {isWidgetModalOpen && (
        <WidgetCreateModal
          widgetId={null}
          /* onSuccess={onSuccessDock} setIsModalOpen={setIsModalOpen} */ onCancel={() => {
            setIsWidgetModalOpen(false);
          }}
        />
      )}
      {isAddApplicationModal && (
        <AddApplicationModal
          type={applicationType}
          application={editApplication}
          onSuccess={onSuccessApplicationAdd}
          errorMsg={errorMsg}
          onCancel={() => {
            setIsAddApplicationModal(false);
            setErrorMsg("");
            setEditApplication(null);
          }}
        />
      )}
      <div className="style-justify-between px-3" style={{ height: "56px", background: "#FFFFFF" }}>
        <div className="style-justify-start">
          <img src={backarrow} alt="back" onClick={() => navigate(-1)} className="cursor-pointer" /* style={{ width: "14px", height: "14px" }} */ />
          <div className="ps-3 font15-700-21272C">Add device group</div>
        </div>
        <div className="style-justify-start">
          <div className="style-justify-end">
            <div onClick={() => navigate(-1)} className="cancel-modal-btn style-justify-center">
              Cancel
            </div>
            <div className="save-modal-btn style-justify-center" onClick={() => submitGroup()}>
              {id != null ? "Update " : "Save "}
            </div>
          </div>
        </div>
      </div>

      <div
        className="mt-2 py-2"
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          margin: "0px 16px",
        }}
      >
        <Row className="px-0" style={{ width: "100%", padding: "0px 12px" }}>
          <Col xs={12} sm={12} md={3} lg={3} xxl={2} className="mt-2">
            <div className="ps-2">
              <div className="font20-500-21272C">Add device group</div>
              <div className="font13-400-66737E">Enter the details for given fields to configure the signage role.</div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xxl={2} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">
              Group ID<span style={{ color: "#FF4444" }}>*</span>
            </div>
            <input type="text" placeholder="Enter here" className="input-field w-100" value={groupId} onChange={(e) => setGroupId(e.target.value)} />
            <span className="field-error">{validations.group_id}</span>
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xxl={2} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">
              Group Name<span style={{ color: "#FF4444" }}>*</span>
            </div>
            <input type="text" placeholder="Enter here" className="input-field w-100" value={groupName} onChange={(e) => setGroupName(e.target.value)} />
            <span className="field-error">{validations.group_name}</span>
          </Col>
          <Col xs={12} sm={12} md={3} lg={2} className="mt-2 px-0 ps-md-1">
            <div className="field-title mb-2">Status</div>
            <select
              className="input-field"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
              }}
              style={{
                borderRadius: "12px",
                gap: "8px",
                backgroundColor: "#F5F5F5",
                border: "none",
              }}
            >
              <option value="Active">Active</option>
              <option value="In-Active">In-Active</option>
            </select>
          </Col>
        </Row>
      </div>
      <div className="mt-2 py-2">
        <Row style={{ width: "100%", padding: "0px 12px" }}>
          <Col xs={12} sm={12} md={4} lg={3} xxl={2}>
            <div
              style={{
                background: "#FFFFFF",
                borderRadius: "16px",
                padding: "14px",
              }}
            >
              <div className="style-justify-between">
                <div>
                  <div className="font13-700-21272C">Applications</div>
                  <span className="field-error">{validations.applications}</span>
                </div>

                {/*  {applicationType==='External' &&( */}
                <div
                  className="font13-400-F1583C"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setIsAddApplicationModal(true);
                  }}
                >
                  {" "}
                  <span style={{ fontSize: "15px" }}>+</span> Add
                </div>
              </div>
              <div className="mt-2" style={{ height: "2px", borderBottom: "2px solid #F2F4F3" }}></div>
              <div className="mt-2">
                <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
                  <div
                    onClick={() => {
                      setApplicationType("Internal");
                      setSelectedApplicationName("");
                      setSelectedApplication(null);
                    }}
                    className={`px-3 style-justify-center cursor-pointer ${applicationType === "Internal" ? "application-active-tab" : "application-inactive-tab"}`}
                  >
                    Internal
                  </div>
                  <div
                    onClick={() => {
                      setApplicationType("External");
                      setSelectedApplicationName("");
                      setSelectedApplication(null);
                    }}
                    className={`px-3 style-justify-center cursor-pointer ${applicationType === "External" ? "application-active-tab" : "application-inactive-tab"}`}
                  >
                    External
                  </div>
                </div>
                <div className="mt-2">
                  {applicationList
                    ?.filter((item) => item.type === applicationType)
                    .map((application, i) => (
                      <div
                        key={`application-list-${i}`}
                        onClick={() => {
                          setSelectedApplicationName(application.name);
                          setSelectedApplication(application);
                          /*  if (id != null && id !== "") {
                            getApplicationWidgetList(
                              application.application_id
                            );
                          } */
                        }}
                        className={`${selectedApplicationName === application.name ? "selected-application-group" : "unselected-application-group"} style-justify-between px-2 cursor-pointer`}
                      >
                        <div className="style-justify-start" style={{ flex: 1 }}>
                          <div>{application.name}</div>
                        </div>
                        <div className="style-justify-start">
                          {((applicationType === "Internal" && application.id === "") || (applicationType === "External" && application.application_id === "")) && (
                            <div>
                              <img
                                src={edit}
                                alt="Edit"
                                className="icon-img me-2"
                                onClick={() => {
                                  setEditApplication(application);
                                  setEditApplicationIndex(i);
                                }}
                              />
                            </div>
                          )}
                          {((applicationType === "Internal" && application.id === "") || (applicationType === "External" && application.application_id === "")) && (
                            <div>
                              <img
                                src={del}
                                alt="Delete"
                                className="icon-img me-2"
                                onClick={() => {
                                  setApplicationList((prev) => prev.filter((item) => item !== application));
                                  setSelectedApplicationName("");
                                  setSelectedApplication(null);
                                }}
                              />
                            </div>
                          )}
                          <div className={`${selectedApplicationName === application.name ? "selected-application-switch" : "unselected-application-switch"} ps-2`}>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={application.selected_status}
                                onChange={() => {
                                  const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === application.application_id && app.name === application.name) || (app.type === "External" && app.application_id === "" && app.name === application.name));
                                  console.log("exte index........", index);
                                  if (index > -1) {
                                    const tempApp = [...applicationList];
                                    tempApp[index].selected_status = !application.selected_status;
                                    if (tempApp[index].selected_status === true) {
                                      tempApp[index].data_flow = "Org";
                                    }
                                    console.log("tempApp[index].selected_status", tempApp[index].selected_status);
                                    setApplicationList(tempApp);
                                    if (application.type === "Internal") {
                                      if (tempApp[index].selected_status === false && !removedInternalList.includes(application.application_id)) {
                                        setRemovedInternalList([...removedInternalList, application.application_id]);
                                      }
                                      if (tempApp[index].selected_status === true && removedInternalList.includes(application.application_id)) {
                                        setRemovedInternalList(removedInternalList.filter((n) => n !== application.application_id));
                                      }
                                    }

                                    if (application.type === "External") {
                                      if (tempApp[index].selected_status === false && !removedExternalList.includes(application.application_id)) {
                                        setRemovedExternalList([...removedExternalList, application.application_id]);
                                      }
                                      if (tempApp[index].selected_status === true && removedExternalList.includes(application.application_id)) {
                                        setRemovedExternalList(removedExternalList.filter((n) => n !== application.application_id));
                                      }
                                    }
                                  }
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </Col>
          {selectedApplication != null && selectedApplication.selected_status === true && (
            <Col xs={12} sm={12} md={8} lg={9} xxl={10}>
              <div
                style={{
                  background: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "14px",
                }}
              >
                <div className="style-justify-between">
                  <div className="style-justify-start">
                    <div>
                      {selectedApplication.application_id !== "" && <img src={selectedApplication.icon_name} alt="appicon" style={{ height: "47px" }} />}
                      {selectedApplication.application_id === "" && selectedApplication.icon !== null && selectedApplication.icon !== "" && <img src={selectedApplication.icon} alt="appicon" style={{ height: "47px" }} />}
                    </div>
                    <div className="ms-2">
                      <div className="font15-700-21272C">{selectedApplication.name}</div>
                      <div className="font13-400-66737E">Configure the all details for this application in this page with your conditions.</div>
                    </div>
                  </div>
                  <div>
                    <select
                      className="input-field w-100"
                      value={selectedApplication.data_flow}
                      onChange={(e) => {
                        const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                        if (index > -1) {
                          const tempApp = [...applicationList];
                          tempApp[index].data_flow = e.target.value;
                          setSelectedApplication(tempApp[index]);
                          setApplicationList(tempApp);
                        }
                      }}
                      style={{
                        borderRadius: "12px",
                        gap: "8px",
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #D7E1EB",
                      }}
                    >
                      <option value="">Select data flow</option>
                      <option value="User">User</option>
                      <option value="Location">Location</option>
                      <option value="Department">Department</option>
                      <option value="Org">Org</option>
                    </select>
                  </div>
                </div>
              </div>

              <div
                className="mt-2"
                style={{
                  background: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "14px",
                }}
              >
                <div className="font16-500-21272C">Duration</div>
                <div className="font13-400-66737E  mb-1">The "duration in seconds" specifies the time span for which the dashboard will display information.</div>
                <div className="style-justify-start">
                  <div style={{ width: "175px" }}>
                    <input
                      type="text"
                      placeholder="Enter duration"
                      className="input-field w-100"
                      value={selectedApplication.duration_time}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                        if (index > -1) {
                          const tempApp = [...applicationList];
                          tempApp[index].duration_time = value;
                          setSelectedApplication(tempApp[index]);
                          setApplicationList(tempApp);
                        }
                      }}
                    />
                  </div>
                  <div>
                    <div className="ms-2" style={{ width: "175px" }}>
                      <input
                        type="text"
                        placeholder="Enter interval"
                        className="input-field w-100"
                        value={selectedApplication.interval_time}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                          if (index > -1) {
                            const tempApp = [...applicationList];
                            tempApp[index].interval_time = value;
                            setSelectedApplication(tempApp[index]);
                            setApplicationList(tempApp);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="mt-2"
                style={{
                  background: "#FFFFFF",
                  borderRadius: "16px",
                  padding: "14px",
                }}
              >
                <div className="font16-500-21272C">Sequence Order</div>
                <div className="font13-400-66737E mb-1">The "sequence number" defines the order in which the dashboard should present its content.</div>
                <div className="style-justify-start">
                  <div style={{ width: "175px" }}>
                    <input
                      type="text"
                      placeholder="Enter here"
                      className="input-field w-100"
                      value={selectedApplication.sequence_order}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                        if (index > -1) {
                          const tempApp = [...applicationList];
                          tempApp[index].sequence_order = value;
                          setSelectedApplication(tempApp[index]);
                          setApplicationList(tempApp);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {selectedApplication.type === "Internal" && (
                <div
                  className="mt-2"
                  style={{
                    background: "#FFFFFF",
                    borderRadius: "16px",
                    padding: "14px",
                  }}
                >
                  <div className="font16-500-21272C">Widgets</div>
                  {selectedApplication.internal_widgets != null &&
                    selectedApplication.internal_widgets?.map((widget, wIndex) => {
                      return (
                        <div className="style-justify-start mt-2">
                          <div style={{ width: "56px" }}>
                            <input
                              type="text"
                              placeholder=""
                              className="input-field w-100"
                              value={selectedApplication.internal_widgets[wIndex].seq_no}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                if (index > -1) {
                                  const tempApp = [...applicationList];
                                  tempApp[index].internal_widgets[wIndex].seq_no = value;
                                  setSelectedApplication(tempApp[index]);
                                  setApplicationList(tempApp);
                                }
                              }}
                            />
                          </div>
                          <div
                            className="style-justify-start ms-3"
                            style={{
                              width: "400px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                              padding: "10px",
                              background: "#F9F9F9",
                              borderRadius: "8px",
                            }}
                          >
                            {widget.name ?? ""}
                          </div>
                          <div className="ms-3">
                            <input
                              type="checkbox"
                              checked={widget.status}
                              onChange={(e) => {
                                const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                if (index > -1) {
                                  const tempApp = [...applicationList];
                                  tempApp[index].internal_widgets[wIndex].status = e.target.checked;
                                  setSelectedApplication(tempApp[index]);
                                  setApplicationList(tempApp);
                                }
                              }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "0 0 12px 24px" }}>
                            <label style={{ fontWeight: "600", fontSize: "14px", color: "#333" }}>Width:</label>
                            <select
                              value={widget.width || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                if (index > -1) {
                                  const tempApp = [...applicationList];
                                  tempApp[index].internal_widgets[wIndex].width = value;
                                  setSelectedApplication(tempApp[index]);
                                  setApplicationList(tempApp);
                                }
                              }}
                              style={{ width: "160px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "10px", backgroundColor: "#f9f9f9", fontSize: "14px", color: "#ff0000ff", cursor: "pointer", outline: "none" }}
                            >
                              <option value="">Select</option>
                              <option value="small">Small</option>
                              <option value="medium">Medium</option>
                              <option value="large">Large</option>
                              <option value="custom">Custom</option>
                            </select>
                            {widget.width === "custom" && (
                              <input
                                type="number"
                                placeholder="Custom width"
                                value={widget.custom_width}
                                onChange={(e) => {
                                  const customValue = e.target.value;
                                  const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                  if (index > -1) {
                                    const tempApp = [...applicationList];
                                    tempApp[index].internal_widgets[wIndex].custom_width = customValue;
                                    setSelectedApplication(tempApp[index]);
                                    setApplicationList(tempApp);
                                  }
                                }}
                                style={{ width: "90px", padding: "6px 10px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px" }}
                              />
                            )}
                            {widget.width === "small" && <input type="number" value={150} readOnly style={{ width: "90px", padding: "6px 10px", border: "none", borderRadius: "6px", fontSize: "14px", background: "#eee", cursor:"not-allowed" }} />}
                            {widget.width === "medium" && <input type="number" value={250} readOnly style={{ width: "90px", padding: "6px 10px", border: "none", borderRadius: "6px", fontSize: "14px", background: "#eee", cursor:"not-allowed" }} />}
                            {widget.width === "large" && <input type="number" value={400} readOnly style={{ width: "90px", padding: "6px 10px", border: "none", borderRadius: "6px", fontSize: "14px", background: "#eee", cursor:"not-allowed" }} />}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
              {selectedApplication.type === "External" && (
                <div
                  className="mt-2"
                  style={{
                    background: "#FFFFFF",
                    borderRadius: "16px",
                    padding: "14px",
                  }}
                >
                  <div className="font16-500-21272C">Widgets or Embedded link</div>
                  <div className="font13-400-66737E mb-1">Choose multiple widgets to be showcased in the dashboard, selecting those that best represent the desired information or insights.</div>
                  {/* {widgets.map((widget, i) => ( */}
                  <div className="style-justify-start">
                    <div style={{ width: "175px" }}>
                      <select
                        className="input-field w-100"
                        value={selectedApplication.widget_type}
                        onChange={(e) => {
                          const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                          if (index > -1) {
                            const tempApp = [...applicationList];
                            tempApp[index].widget_type = e.target.value;
                            setSelectedApplication(tempApp[index]);
                            setApplicationList(tempApp);
                          }
                        }}
                        style={{
                          borderRadius: "12px",
                          gap: "8px",
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #D7E1EB",
                        }}
                      >
                        <option value="Widgets">Widgets</option>
                        <option value="Embedded">Embedded link</option>
                      </select>
                    </div>
                    {selectedApplication.widget_type === "Widgets" && (
                      <div style={{ width: "300px" }} className="ms-2">
                        <select
                          className="input-field w-100"
                          value={durationType}
                          onChange={(e) => {
                            setDurationType(e.target.value);
                          }}
                          style={{
                            borderRadius: "12px",
                            gap: "8px",
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #D7E1EB",
                          }}
                        >
                          <option value="">Chart</option>
                        </select>
                      </div>
                    )}
                    {selectedApplication.widget_type === "Embedded" && (
                      <div className="ms-2 " style={{ width: "300px" }}>
                        <input
                          type="text"
                          placeholder="Enter here"
                          className="input-field w-100"
                          value={selectedApplication.embedded_link}
                          onChange={(e) => {
                            const value = e.target.value;
                            const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                            if (index > -1) {
                              const tempApp = [...applicationList];
                              tempApp[index].embedded_link = value;
                              setSelectedApplication(tempApp[index]);
                              setApplicationList(tempApp);
                            }
                          }}
                        />
                      </div>
                    )}
                    {applicationType === "Internal" && selectedApplication.widget_type === "Widgets" && (
                      <div
                        onClick={() => {
                          setIsWidgetModalOpen(true);
                          /*  const tempWidgets=[...widgets];
               tempWidgets.push({widget_type:'', chart:'', config:{}})
               setWidgets(tempWidgets) */
                        }}
                        className="ms-2 "
                        style={{
                          width: "100px",
                          height: "36px",
                          borderRadius: "8px",
                          background: "#FFF2EF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#F1583C",
                        }}
                      >
                        Add widget
                      </div>
                    )}
                  </div>
                  {applicationType === "Internal" &&
                    selectedApplication.internal_widgets != null &&
                    selectedApplication.internal_widgets.map((widget, wIndex) => {
                      return (
                        <div className="style-justify-start mt-2">
                          <div style={{ width: "56px" }}>
                            <input
                              type="text"
                              placeholder=""
                              className="input-field w-100"
                              value={selectedApplication.internal_widgets[wIndex].seq_no}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                if (index > -1) {
                                  const tempApp = [...applicationList];
                                  tempApp[index].internal_widgets[wIndex].seq_no = value;
                                  setSelectedApplication(tempApp[index]);
                                  setApplicationList(tempApp);
                                }
                              }}
                            />
                          </div>
                          <div
                            className="style-justify-start ms-3"
                            style={{
                              width: "400px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                              padding: "10px",
                              background: "#F9F9F9",
                              borderRadius: "8px",
                            }}
                          >
                            {widget.name ?? ""}
                          </div>
                          <div className="ms-3">
                            <input
                              type="checkbox"
                              checked={widget.status}
                              onChange={(e) => {
                                const index = applicationList.findIndex((app) => (app.type === applicationType && app.application_id != null && app.application_id === selectedApplication.application_id && app.name === selectedApplication.name) || (applicationType === "External" && app.application_id === "" && app.name === selectedApplication.name));
                                if (index > -1) {
                                  const tempApp = [...applicationList];
                                  tempApp[index].internal_widgets[wIndex].status = e.target.checked;
                                  setSelectedApplication(tempApp[index]);
                                  setApplicationList(tempApp);
                                }
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
}
